// deleteAppointmentFromDb.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl =
  process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:5000";

const deleteAppointmentFromDb = createAsyncThunk(
  "appointments/deleteFromDb",
  async (appointmentId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      // 🔥 HARD DELETE API CALL
      await axios.delete(`${baseUrl}/appointments/${appointmentId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return appointmentId;
    } catch (error) {
      console.error("Delete Appointment Error:", error);

      return rejectWithValue(
        error.response?.data?.message || "Failed to delete appointment",
      );
    }
  },
);

export default deleteAppointmentFromDb;
